export const productreportdata = [
  {
    id:"1",
    SKU: "PT001",
    Product_Name: "Lenovo IdeaPad 3",
    image: "assets/img/products/stock-img-01.png",
    Category: "Computers",
    Brand: "Lenovo",
    Qty: 100,
    Price: "$600",
    Total_Ordered: 5000,
    Revenue: "$787258",
  },
  {
    id:"2",
    SKU: "PT002",
    Product_Name: "Beats Pro",
    image: "assets/img/products/stock-img-06.png",
    Category: "Electronics",
    Brand: "Beats",
    Qty: 140,
    Price: "$160",
    Total_Ordered: 4860,
    Revenue: "$689788",
  },
  {
    id:"3",
    SKU: "PT003",
    Product_Name: "Nike Jordan",
    image: "assets/img/products/stock-img-02.png",
    Category: "Shoe",
    Brand: "Nike",
    Qty: 300,
    Price: "$110",
    Total_Ordered: 40,
    Revenue: "$7757",
  },
  {
    id:"4",
    SKU: "PT004",
    Product_Name: "Apple Series 5 Watch",
    image: "assets/img/products/stock-img-03.png",
    Category: "Electronics",
    Brand: "Apple",
    Qty: 450,
    Price: "$120",
    Total_Ordered: 9642,
    Revenue: "$7555",
  },
  {
    id:"5",
    SKU: "PT005",
    Product_Name: "Amazon Echo Dot",
    image: "assets/img/products/stock-img-04.png",
    Category: "Electronics",
    Brand: "Amazon",
    Qty: 320,
    Price: "$80",
    Total_Ordered: 5464,
    Revenue: "$39698",
  },
  {
    id:"6",
    SKU: "PT006",
    Product_Name: "Sanford Chair Sofa",
    image: "assets/img/products/stock-img-05.png",
    Category: "Furniture",
    Brand: "Modern Wave",
    Qty: 650,
    Price: "$320",
    Total_Ordered: 158,
    Revenue: "$748",
  },
  {
    id:"7",
    SKU: "PT007",
    Product_Name: "Red Premium Satchel",
    image: "assets/img/products/expire-product-01.png",
    Category: "Bags",
    Brand: "Dior",
    Qty: 700,
    Price: "$60",
    Total_Ordered: 7845,
    Revenue: "$7985",
  },
  {
    id:"8",
    SKU: "PT008",
    Product_Name: "Iphone 14 Pro",
    image: "assets/img/products/expire-product-02.png",
    Category: "Phone",
    Brand: "Apple",
    Qty: 630,
    Price: "$540",
    Total_Ordered: 540,
    Revenue: "$8769798",
  },
  {
    id:"9",
    SKU: "PT009",
    Product_Name: "Gaming Chair",
    image: "assets/img/products/expire-product-03.png",
    Category: "Furniture",
    Brand: "Arlime",
    Qty: 410,
    Price: "$200",
    Total_Ordered: 200,
    Revenue: "$788979",
  },
  {
    id:"10",
    SKU: "PT010",
    Product_Name: "Borealis Backpack",
    image: "assets/img/products/expire-product-04.png",
    Category: "Bags",
    Brand: "The North Face",
    Qty: 550,
    Price: "$45",
    Total_Ordered: 45,
    Revenue: "$895",
  },
];
export const productexpireddata = [
  {
    id:"1",
    SKU: "PT001",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Lenovo IdeaPad 3",
    image: "assets/img/products/stock-img-01.png",
    Manufactured_Date: "24 Dec 2024",
    Expired_Date: "20 Dec 2026",
  },
  {
    id:"2",
    SKU: "PT002",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Beats Pro",
    image: "assets/img/products/stock-img-06.png",
    Manufactured_Date: "25 Dec 2024",
    Expired_Date: "21 Dec 2026",
  },
  {
    id:"3",
    SKU: "PT003",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Nike Jordan",
    image: "assets/img/products/stock-img-02.png",
    Manufactured_Date: "26 Dec 2024",
    Expired_Date: "22 Dec 2026",
  },
  {
    id:"4",
    SKU: "PT004",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Apple Series 5 Watch",
    image: "assets/img/products/stock-img-03.png",
    Manufactured_Date: "30 Dec 2024",
    Expired_Date: "25 Dec 2026",
  },
  {
    id:"5",
    SKU: "PT005",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Amazon Echo Dot",
    image: "assets/img/products/stock-img-04.png",
    Manufactured_Date: "28 Dec 2024",
    Expired_Date: "26 Dec 2026",
  },
  {
    id:"6",
    SKU: "PT006",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Sanford Chair Sofa",
    image: "assets/img/products/stock-img-05.png",
    Manufactured_Date: "24 Dec 2024",
    Expired_Date: "29 Dec 2026",
  },
  {
    id:"7",
    SKU: "PT007",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Red Premium Satchel",
    image: "assets/img/products/expire-product-01.png",
    Manufactured_Date: "15 Dec 2024",
    Expired_Date: "30 Dec 2026",
  },
  {
    id:"8",
    SKU: "PT008",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Iphone 14 Pro",
    image: "assets/img/products/expire-product-02.png",
    Manufactured_Date: "24 Dec 2024",
    Expired_Date: "20 Dec 2026",
  },
  {
    id:"9",
    SKU: "PT009",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Gaming Chair",
    image: "assets/img/products/expire-product-03.png",
    Manufactured_Date: "30 Dec 2024",
    Expired_Date: "20 Dec 2026",
  },
  {
    id:"10",
    SKU: "PT010",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Borealis Backpack",
    image: "assets/img/products/expire-product-04.png",
    Manufactured_Date: "24 Dec 2024",
    Expired_Date: "20 Dec 2026",
  },
];
export const productqualitydata = [
  {
    id:"1",
    SKU: "PT001",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Lenovo IdeaPad 3",
    image:"assets/img/products/stock-img-01.png",
    Total_Quantity: 98,
    Alert_Quantity: 79,
  },
  {
    id:"2",
    SKU: "PT002",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Beats Pro",
    image:"assets/img/products/stock-img-06.png",
    Total_Quantity: 156,
    Alert_Quantity: 66,
  },
  {
    id:"3",
    SKU: "PT003",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Nike Jordan",
    image:"assets/img/products/stock-img-02.png",
    Total_Quantity: 89,
    Alert_Quantity: 69,
  },
  {
    id:"4",
    SKU: "PT004",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Apple Series 5 Watch",
    image:"assets/img/products/stock-img-03.png",
    Total_Quantity: 569,
    Alert_Quantity: 68,
  },
  {
    id:"5",
    SKU: "PT005",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Amazon Echo Dot",
    image:"assets/img/products/stock-img-04.png",
    Total_Quantity: 548,
    Alert_Quantity: 33,
  },
  {
    id:"6",
    SKU: "PT006",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Sanford Chair Sofa",
    image:"assets/img/products/stock-img-05.png",
    Total_Quantity: 456,
    Alert_Quantity: 16,
  },
  {
    id:"7",
    SKU: "PT007",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Red Premium Satchel",
    image:"assets/img/products/expire-product-01.png",
    Total_Quantity: 178,
    Alert_Quantity: 86,
  },
  {
    id:"8",
    SKU: "PT008",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Iphone 14 Pro",
    image:"assets/img/products/expire-product-02.png",
    Total_Quantity: 1768,
    Alert_Quantity: 33,
  },
  {
    id:"9",
    SKU: "PT009",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Gaming Chair",
    image:"assets/img/products/expire-product-03.png",
    Total_Quantity: 568,
    Alert_Quantity: 528,
  },
  {
    id:"10",
    SKU: "PT010",
    Serial_No: "LNV-IP3-8GB-256SSD-BL",
    Product_Name: "Borealis Backpack",
    image:"assets/img/products/expire-product-04.png",
    Total_Quantity: 146,
    Alert_Quantity: 11,
  },
];
